import './navbar.css';
import React, { useEffect, useState } from 'react';
import Logo from '../../Assets/images/Logos/Nav-Logo.avif';

const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <nav className={`NavBar-Component${scrolled ? ' scrolled' : ''}`}>
      <div className="NavBar-inner">
        <div className="Img-Container">
          <img
            alt="Masini Asociados"
            src={Logo}
            onClick={scrollToTop}
            className="NavBar-logo"
            decoding="async"
            fetchPriority="high"
          />
        </div>
        <div className="Info-Container">
          <p>
            Estudio Jurídico
            <br />
            Asesoramiento Personalizado
          </p>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
